export const memberActions = {
  DELETE: {
    id: 1,
    label: 'Quitar',
    verb: 'Quitar',
    icon: 'delete',
    apiKey: 'delete',
    className: 'fdca-delete',
    mobileClassName:'m-fdca-delete'
  },
  ADD: {
    id: 2,
    label: 'Agregar a Formación',
    verb: 'Agregar',
    icon: 'add',
    apiKey: 'add',
    className: 'fdca-add',
    mobileClassName:'m-fdca-add'

  },
  // PAY: {
  //   id: 3,
  //   label: 'Cobrar',
  //   verb: 'Cobrar',
  //   icon: 'attach_money',
  //   apiKey: 'pay',
  //   className: 'fdca-pay',
  //   mobileClassName:'m-fdca-pay'
  // },

  VIEW: {
    id: 4,
    label: 'Ver Miembro',
    verb: 'ver',
    icon: 'visibility',
    className: 'm-fdca-view',
    mobileClassName:'m-fdca-view'
  }
}